let ctx = null;
let muted = true;
let ambientOsc = null;
let ambientGain = null;

const getCtx = () => {
  if (!ctx) {
    ctx = new (window.AudioContext || window.webkitAudioContext)();
  }
  if (ctx.state === 'suspended') ctx.resume();
  return ctx;
};

export const playBlockChime = () => {
  if (muted) return;
  try {
    const ac = getCtx();
    const osc = ac.createOscillator();
    const gain = ac.createGain();
    osc.type = 'sine';
    osc.frequency.setValueAtTime(880, ac.currentTime);
    osc.frequency.exponentialRampToValueAtTime(440, ac.currentTime + 0.3);
    gain.gain.setValueAtTime(0.12, ac.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.001, ac.currentTime + 0.8);
    osc.connect(gain).connect(ac.destination);
    osc.start(ac.currentTime);
    osc.stop(ac.currentTime + 0.8);
  } catch (e) {

  }
};

export const updateAmbientTone = (direction) => {
  if (muted) {
    stopAmbient();
    return;
  }
  try {
    const ac = getCtx();
    if (!ambientOsc) {
      ambientOsc = ac.createOscillator();
      ambientGain = ac.createGain();
      ambientOsc.type = 'sine';
      ambientGain.gain.value = 0.015;
      ambientOsc.connect(ambientGain).connect(ac.destination);
      ambientOsc.start();
    }
    const freq = direction === 'up' ? 220 : direction === 'down' ? 150 : 180;
    ambientOsc.frequency.linearRampToValueAtTime(freq, ac.currentTime + 2);
  } catch (e) {

  }
};

const stopAmbient = () => {
  if (ambientOsc) {
    try {
      ambientOsc.stop();
    } catch (e) {

    }
    ambientOsc = null;
    ambientGain = null;
  }
};

export const setMuted = (val) => {
  muted = val;
  if (muted) stopAmbient();
};

export const getIsMuted = () => muted;

export const playHodlSound = () => {
  if (muted) return;
  try {
    const ac = getCtx();
    const t = ac.currentTime;

    // Low boom
    const boom = ac.createOscillator();
    const boomGain = ac.createGain();
    boom.type = 'sine';
    boom.frequency.setValueAtTime(80, t);
    boom.frequency.exponentialRampToValueAtTime(40, t + 0.8);
    boomGain.gain.setValueAtTime(0.2, t);
    boomGain.gain.exponentialRampToValueAtTime(0.001, t + 1.5);
    boom.connect(boomGain).connect(ac.destination);
    boom.start(t);
    boom.stop(t + 1.5);

    // Ascending sweep
    const sweep = ac.createOscillator();
    const sweepGain = ac.createGain();
    sweep.type = 'sawtooth';
    sweep.frequency.setValueAtTime(200, t + 0.1);
    sweep.frequency.exponentialRampToValueAtTime(800, t + 1.2);
    sweepGain.gain.setValueAtTime(0.08, t + 0.1);
    sweepGain.gain.exponentialRampToValueAtTime(0.001, t + 1.5);
    sweep.connect(sweepGain).connect(ac.destination);
    sweep.start(t + 0.1);
    sweep.stop(t + 1.5);
  } catch (e) {}
};

export const playMilestoneSound = () => {
  if (muted) return;
  try {
    const ac = getCtx();
    const t = ac.currentTime;
    // Ascending chord: C4, E4, G4, C5
    const freqs = [261.63, 329.63, 392.00, 523.25];
    freqs.forEach((freq, i) => {
      const osc = ac.createOscillator();
      const gain = ac.createGain();
      osc.type = 'sine';
      osc.frequency.setValueAtTime(freq, t);
      const onset = t + i * 0.15;
      gain.gain.setValueAtTime(0, onset);
      gain.gain.linearRampToValueAtTime(0.1, onset + 0.05);
      gain.gain.exponentialRampToValueAtTime(0.001, onset + 1.5);
      osc.connect(gain).connect(ac.destination);
      osc.start(onset);
      osc.stop(onset + 1.5);
    });
  } catch (e) {}
};
